import React from "react";

import theme from "config/theme";

import { BlockWrapper, IntroBlock } from "components/Block";
import { Container, Block } from "components/Grid";
import Icon from "components/Icon";

import { Wrapper, Item, Title, Text } from "./styles";

const Socials = ({ content }) => {
  return (
    <Container bg={theme.color.paper}>
      <BlockWrapper pb="30px">
        <IntroBlock content={content} />
        <Wrapper>
          {content.items.map((item, index) => (
            <Item
              key={index}
              href={item.path}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon
                icon={item.icon}
                m="0 25px 25px 0"
                color={theme.color.gray}
                size="40px"
              />
              <Block flex="1" zIndex="2">
                <Title>{item.title}</Title>
                <Text>{item.text}</Text>
              </Block>
            </Item>
          ))}
        </Wrapper>
      </BlockWrapper>
    </Container>
  );
};

export default Socials;
